import { useState } from "react";

const sections = [
  {
    id: 1,
    title: "About Wrio",
    icon: "ℹ️",
    content:
      "Wrio is a SaaS platform providing order entry, distribution management, reporting, analytics, and related tools for franchise and food-industry businesses.",
    bullets: null,
  },
  {
    id: 2,
    title: "Eligibility",
    icon: "✓",
    content: null,
    bullets: [
      "Minimum age 18 years.",
      "Authority to bind the business you represent.",
      "Accurate registration information.",
    ],
  },
  {
    id: 3,
    title: "Accounts",
    icon: "👤",
    content: null,
    bullets: [
      "Keep credentials confidential.",
      "All activity under your account is your responsibility.",
      "Notify us of unauthorized use.",
    ],
  },
  {
    id: 4,
    title: "Subscription & Payments",
    icon: "💳",
    content:
      "Fees are billed per your chosen plan. Taxes are your responsibility. Late payments may cause suspension. Refunds apply only if agreed in writing.",
    bullets: null,
  },
  {
    id: 5,
    title: "Acceptable Use",
    icon: "⚠️",
    content: null,
    bullets: [
      "No reverse engineering or resale.",
      "No malware or hacking attempts.",
      "No unlawful use.",
      "No scraping or abuse.",
    ],
  },
  {
    id: 6,
    title: "Intellectual Property",
    icon: "©️",
    content:
      "All intellectual property rights belong to Devise Apps. A limited, non-transferable license is granted for internal business use only.",
    bullets: null,
  },
  {
    id: 7,
    title: "Customer Data",
    icon: "💾",
    content:
      "You retain ownership of your data. You grant Devise Apps permission to process it to provide the Services and generate anonymized analytics.",
    bullets: null,
  },
  {
    id: 8,
    title: "Third-Party Services",
    icon: "🔗",
    content:
      "The Services may integrate with third-party providers. Devise Apps is not responsible for third-party services or availability.",
    bullets: null,
  },
  {
    id: 9,
    title: "Service Availability",
    icon: "🌐",
    content:
      "We do not guarantee uninterrupted service. Maintenance or outages may occur from time to time.",
    bullets: null,
  },
  {
    id: 10,
    title: "Disclaimer",
    icon: "⚖️",
    content:
      'Services are provided "AS IS" without warranties of any kind to the maximum extent permitted by law.',
    bullets: null,
  },
  {
    id: 11,
    title: "Limitation of Liability",
    icon: "🛡️",
    content:
      "Total liability is limited to the fees paid by you in the preceding 12 months.",
    bullets: null,
  },
  {
    id: 12,
    title: "Indemnification",
    icon: "🤝",
    content:
      "You agree to indemnify and hold harmless Devise Apps against claims arising from your breach of these Terms.",
    bullets: null,
  },
  {
    id: 13,
    title: "Termination",
    icon: "🚫",
    content:
      "We may suspend or terminate access at any time for breach or legal compliance reasons.",
    bullets: null,
  },
  {
    id: 14,
    title: "Governing Law",
    icon: "🏛️",
    content:
      "These Terms are governed by Indian law. Courts in Pune, India have exclusive jurisdiction.",
    bullets: null,
  },
  {
    id: 15,
    title: "Changes to Terms",
    icon: "📝",
    content:
      "We may update these Terms periodically. Continued use constitutes acceptance of the updated Terms.",
    bullets: null,
  },
];

function AccordionSection({ section, isOpen, onToggle }) {
  return (
    <div
      style={{
        borderRadius: 16,
        border: isOpen ? "2px solid #16a34a" : "1px solid #e2e8f0",
        overflow: "hidden",
        background: "#fff",
        boxShadow: isOpen ? "0 8px 30px rgba(22,163,74,0.15)" : "0 2px 8px rgba(0,0,0,0.04)",
        transition: "all 0.35s cubic-bezier(.4,0,.2,1)",
        marginBottom: 16,
      }}
    >
      <button
        onClick={onToggle}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: "20px 28px",
          background: isOpen ? "linear-gradient(135deg, #f0fdf4, #dcfce7)" : "#fff",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
          transition: "background 0.35s ease",
        }}
      >
        <span style={{ fontSize: 28, minWidth: 32, textAlign: "center" }}>{section.icon}</span>
        <span
          style={{
            flex: 1,
            fontSize: 17,
            fontWeight: 600,
            color: isOpen ? "#15803d" : "#1e293b",
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            transition: "color 0.3s",
          }}
        >
          {section.id}. {section.title}
        </span>
        <span
          style={{
            fontSize: 24,
            color: isOpen ? "#16a34a" : "#94a3b8",
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.35s cubic-bezier(.4,0,.2,1), color 0.3s",
            fontWeight: 300,
          }}
        >
          +
        </span>
      </button>

      <div
        style={{
          maxHeight: isOpen ? 400 : 0,
          overflow: "hidden",
          transition: "max-height 0.45s cubic-bezier(.4,0,.2,1)",
        }}
      >
        <div style={{ padding: "0 28px 24px 76px" }}>
          {section.bullets ? (
            <ul style={{ margin: 0, paddingLeft: 0 }}>
              {section.bullets.map((b, i) => (
                <li
                  key={i}
                  style={{
                    fontSize: 15,
                    color: "#475569",
                    lineHeight: 2.2,
                    listStyle: "none",
                    paddingLeft: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#16a34a",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  {b}
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ margin: 0, fontSize: 15, color: "#475569", lineHeight: 1.9 }}>{section.content}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default function WrioTermsOfService() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #f8fafc 0%, #e2e8f0 100%)",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        padding: 0,
        margin: 0,
      }}
    >
      {/* Google Font */}
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />

      {/* Full-width Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
          padding: "60px 24px",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 10px 40px rgba(22, 163, 74, 0.25)",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-100px",
            right: "-100px",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.08)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-80px",
            left: "-80px",
            width: "250px",
            height: "250px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.05)",
          }}
        />
        
        <div style={{ maxWidth: "1200px", margin: "0 auto", position: "relative", zIndex: 1 }}>
          <h1
            style={{
              color: "#fff",
              fontSize: "clamp(32px, 5vw, 48px)",
              fontWeight: 800,
              margin: "0 0 16px",
              letterSpacing: "-1px",
            }}
          >
            Terms of Service
          </h1>
          
          <p
            style={{
              color: "rgba(255, 255, 255, 0.95)",
              fontSize: "clamp(16px, 2vw, 20px)",
              margin: "0 0 24px",
              lineHeight: 1.7,
              maxWidth: "800px",
            }}
          >
            These Terms of Service govern your access to and use of the Wrio platform operated by Devise Apps.
          </p>
          
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(255, 255, 255, 0.18)",
              backdropFilter: "blur(8px)",
              borderRadius: "30px",
              padding: "10px 20px",
              marginBottom: "20px",
              border: "1px solid rgba(255, 255, 255, 0.25)",
            }}
          >
            <span style={{ fontSize: "16px" }}>📜</span>
            <span style={{ color: "#fff", fontSize: "14px", fontWeight: 600 }}>
              Legal Agreement for Platform Use
            </span>
          </div>
          
          <div
            style={{
              color: "rgba(255, 255, 255, 0.75)",
              fontSize: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ fontSize: "18px" }}>📅</span>
            <span>
              Last Updated: <strong style={{ color: "#fff" }}>February 1, 2026</strong>
            </span>
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "48px 24px" }}>
        {/* Key Highlights */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            marginBottom: "48px",
          }}
        >
          {[
            { val: "18+", label: "Age Requirement", icon: "🔞" },
            { val: "India", label: "Governing Law", icon: "🇮🇳" },
            { val: "SaaS", label: "Platform Type", icon: "☁️" },
            { val: "15", label: "Key Sections", icon: "📋" },
          ].map((s) => (
            <div
              key={s.label}
              style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "28px 24px",
                textAlign: "center",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e2e8f0",
                transition: "all 0.3s ease",
                cursor: "default",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(22, 163, 74, 0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.06)";
              }}
            >
              <div style={{ fontSize: "32px", marginBottom: "12px" }}>{s.icon}</div>
              <div style={{ fontWeight: 800, fontSize: "28px", color: "#16a34a", lineHeight: 1.2 }}>
                {s.val}
              </div>
              <div style={{ fontSize: "13px", color: "#64748b", fontWeight: 600, marginTop: "8px" }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* Important Notice */}
        <div
          style={{
            background: "linear-gradient(135deg, #fef3c7, #fde68a)",
            border: "2px solid #fbbf24",
            borderRadius: "16px",
            padding: "24px 28px",
            marginBottom: "32px",
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <span style={{ fontSize: "32px", flexShrink: 0 }}>⚠️</span>
          <div>
            <div style={{ fontWeight: 700, fontSize: "16px", color: "#92400e", marginBottom: "8px" }}>
              Important Notice
            </div>
            <p style={{ margin: 0, fontSize: "14px", color: "#78350f", lineHeight: 1.8 }}>
              By accessing or using Wrio, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our platform. These terms constitute a legally binding agreement between you and Devise Apps.
            </p>
          </div>
        </div>

        {/* Accordion Sections */}
        <div style={{ marginBottom: "48px" }}>
          {sections.map((section, i) => (
            <AccordionSection key={section.id} section={section} isOpen={openIndex === i} onToggle={() => toggle(i)} />
          ))}
        </div>

        {/* Contact Information */}
       
      </div>

      {/* Footer */}
 
    </div>
  );
}